import { DEPRECATED_Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";

export const InfoBoxUI = () => (
  <DEPRECATED_Message
    type="information"
    title="We're unlikely to receive more stock of this item"
    containerProps={{ ["data-component"]: "InfoBox" }}
  />
);
